import React, { memo } from 'react'

import Tab from 'components/Tab/Tab'
import TabLabelWithCount from 'components/TabLabelWithCount/TabLabelWithCount'
import DropdownMenu from 'components/CommonUI/Dropdown'

import { equal } from 'utils/memoEqual'
import {
  facilityFiltedDefaultValue,
  deviceFilterDefaultValue,
  statusValueConstants,
} from '../AlertContainer'

const AlertsFilter = ({
  counts,
  handleChangeTab,
  facilitySelectValue,
  facilityFilterOptions,
  hadnleChangeFacilitySelect,
  devicesSelectValue,
  deviceFilterOptions,
  handleChangeDeviceSelect,
}) => {
  const tabs = [
    {
      label: <TabLabelWithCount label={'Open'} count={counts.open} />,
      value: statusValueConstants.OPEN,
      disabled: !counts.open,
    },
    {
      label: <TabLabelWithCount label={'Resolved'} count={counts.resolve} />,
      value: statusValueConstants.RESOLVE,
      disabled: !counts.resolve,
    },
    {
      label: <TabLabelWithCount label={'All'} count={counts.all} />,
      value: null,
      disabled: !counts.all,
    },
  ]

  return (
    <div className="alerts_filter_container">
      <Tab tabs={tabs} handleChangeTab={handleChangeTab} />
      <div className="selects_filter_container">
        <DropdownMenu
          classNameContainer="selects_alerts selects_filter_facility"
          handleSelectedClick={hadnleChangeFacilitySelect}
          selectedValue={facilitySelectValue}
          defaultValueItem={facilityFiltedDefaultValue}
        >
          {facilityFilterOptions.map((i) => (
            <DropdownMenu.Item key={i.id} itemData={i} />
          ))}
        </DropdownMenu>
        <DropdownMenu
          classNameContainer="selects_alerts selects_filter_facility"
          handleSelectedClick={handleChangeDeviceSelect}
          selectedValue={devicesSelectValue}
          defaultValueItem={deviceFilterDefaultValue}
        >
          {deviceFilterOptions.map((i) => (
            <DropdownMenu.Item key={i.id} itemData={i} />
          ))}
        </DropdownMenu>
      </div>
    </div>
  )
}

export default memo(AlertsFilter, equal)
